import moment from 'moment';

const CALENDAR_DATE_PREFIX = /^(\d{4}-\d{2}-\d{2})/;

/**
 * Serialize a DatePicker value as YYYY-MM-DD (local calendar day).
 */
export const toApiCalendarDate = value => {
  if (value == null || value === '') {
    return null;
  }

  const parsed = moment(value);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : null;
};

/**
 * Parse API calendar date into a local Date for DatePicker.
 * YYYY-MM-DD is treated as a local calendar day (not UTC midnight).
 */
export const parseApiCalendarDate = value => {
  if (value == null || value === '') {
    return null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const asString = String(value);
  const match = CALENDAR_DATE_PREFIX.exec(asString);
  if (match) {
    const parsed = moment(match[1], 'YYYY-MM-DD');
    return parsed.isValid() ? parsed.toDate() : null;
  }

  const parsed = moment(asString);
  return parsed.isValid() ? parsed.toDate() : null;
};
